import { render, staticRenderFns } from "./SeriesList.vue?vue&type=template&id=0e0decce"
import script from "./SeriesList.vue?vue&type=script&lang=js"
export * from "./SeriesList.vue?vue&type=script&lang=js"
import style0 from "./SeriesList.vue?vue&type=style&index=0&id=0e0decce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports